if(typeof _.transform === 'undefined') { var e = new Error("Cannot find module '_.transform'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = _.transform;